// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Information settings */
.settingsTabs_uploadCircle__wsTTO {
  width: 96px;
  height: 96px;
  border-radius: 500px;
  border: 2px solid var(--border);
  background-color: var(--white);
  color: var(--secondary-Text);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  position: relative;
  font: var(--body-font-four);
}
.settingsTabs_uploadCircle__wsTTO span {
  font: var(--body-font-four);
}

.settingsTabs_cameraIcon__SdS06 {
  position: absolute;
  bottom: 0px;
  right: 0px;
  background-color: var(--brand);
  color: var(--white);
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.settingsTabs_cameraIcon__SdS06 img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 4px;
  filter: brightness(0) invert(1);
}

.settingsTabs_horizontal__TZrh3 {
  display: flex;
}

.settingsTabs_profileCard__v91UT {
  padding: 20px;
  border: 1px solid var(--border);
  border-radius: var(--border-radius-large);
  background-color: var(--white);
}
.settingsTabs_profileCard__v91UT .settingsTabs_boxTitle__uCiu7 {
  font: var(--h6);
  font-weight: 600;
  color: var(--primary-Text);
  text-align: start;
  margin-bottom: 16px;
}
.settingsTabs_profileCard__v91UT .settingsTabs_formBox__2dpd0 {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.settingsTabs_profileCard__v91UT .settingsTabs_formBox__2dpd0 p:empty {
  display: none;
}
.settingsTabs_profileCard__v91UT .settingsTabs_formBox__2dpd0 label {
  font: var(--body-font-three);
  color: var(--secondary-Text);
  margin-bottom: 4px;
}
.settingsTabs_profileCard__v91UT .settingsTabs_formBox__2dpd0 input {
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--white);
  margin: 0;
  font: var(--body-font-three);
  color: var(--primary-Text);
  font-weight: 500;
}
.settingsTabs_profileCard__v91UT .settingsTabs_formBox__2dpd0 input:focus, .settingsTabs_profileCard__v91UT .settingsTabs_formBox__2dpd0 input:focus-visible {
  border: 1px solid var(--brand);
  outline: none;
}
.settingsTabs_profileCard__v91UT .settingsTabs_formBox__2dpd0 .settingsTabs_formInputs__yajrF {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}
@media (max-width: 499px) {
  .settingsTabs_profileCard__v91UT .settingsTabs_formBox__2dpd0 .settingsTabs_formInputs__yajrF {
    grid-template-columns: repeat(1, 1fr);
  }
}
.settingsTabs_profileCard__v91UT .settingsTabs_formBox__2dpd0 .settingsTabs_formGroupInnerBox__5SQw1 {
  display: flex;
  align-items: end;
  gap: 16px;
}
.settingsTabs_profileCard__v91UT .settingsTabs_formBox__2dpd0 .settingsTabs_formBtns__ApapP {
  display: flex;
  gap: 10px;
}
.settingsTabs_profileCard__v91UT .settingsTabs_buttonContainer__1Bk3\\+ {
  width: 100%;
  text-align: right;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
}

.settingsTabs_integrationCard__fWmok {
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 16px 16px 0 16px;
  margin-bottom: 0;
  background-color: var(--white);
}

.settingsTabs_cardHeader__28fK5 {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.settingsTabs_cardHeaderLeft__B-iqJ {
  display: flex;
  gap: 16px;
}

.settingsTabs_cardLogo__0M-wv {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}
.settingsTabs_cardLogo__0M-wv img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.settingsTabs_cardTitle__KrP3l {
  margin: 0 0 4px 0;
  font-weight: 600;
  font-size: 16px;
  color: var(--primary-Text);
}

.settingsTabs_cardDescription__zpkYA {
  margin: 0;
  color: var(--secondary-Text);
  font-size: 14px;
  line-height: 20px;
}

.settingsTabs_statusBadge__UT\\+eo {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 10px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 500;
}
.settingsTabs_statusBadge__UT\\+eo.settingsTabs_connected__Q3BZ9 {
  background-color: #EDF7EE;
  color: var(--success);
}
.settingsTabs_statusBadge__UT\\+eo.settingsTabs_disconnected__YNVtE {
  background-color: var(--bg3);
  color: var(--primary-Text);
}

.settingsTabs_statusIcon__ESDyg {
  width: 10px;
  height: 10px;
  object-fit: contain;
}

.settingsTabs_cardActions__94trI {
  margin-left: 16px;
}

.settingsTabs_sectionDivider__VBMeK {
  margin: 16px -16px 0 -16px;
  border: none;
  border-top: 1px solid var(--border);
}

.settingsTabs_integrationCardConnectedContent__TWSCs {
  background-color: var(--bg3);
  border-radius: 8px;
  padding: 16px;
  margin: 0 -16px;
}

.settingsTabs_statusContainer__i5uXs {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  font-size: 14px;
  font-weight: 500;
  color: var(--primary-Text);
}

.settingsTabs_sectionHeader__ZtNfo {
  font-size: 14px;
  font-weight: 600;
  color: var(--primary-Text);
  margin-bottom: 16px;
}

.settingsTabs_settingRow__9am6n {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.settingsTabs_settingRowLabel__QN8X6 {
  font-size: 14px;
  color: var(--secondary-Text);
}

.settingsTabs_settingsGroup__38B9a {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.settingsTabs_feedUrlBox__OOJct {
  margin-top: 0;
  margin-bottom: 16px;
  background-color: #F9FAFB;
  padding: 16px;
  border-radius: 8px;
}

.settingsTabs_feedUrlLayout__jMrJs {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 24px;
  max-width: 720px;
  margin: 0 auto;
}

.settingsTabs_feedUrlColumn__8ODDm {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.settingsTabs_feedUrlOrColumn__GDOpn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  font-size: 12px;
  font-weight: 600;
  color: var(--secondary-Text);
  text-transform: uppercase;
  white-space: nowrap;
}

.settingsTabs_feedUrlLabel__vVLG\\+ {
  margin: 0 0 8px 0;
  font-size: 14px;
  font-weight: 500;
  color: var(--secondary-Text);
}

.settingsTabs_feedUrlInputRow__roVJw {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-direction: column;
}

.settingsTabs_feedUrlInput__gmmvC {
  flex: 1 1;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid var(--border);
  font-size: 13px;
  color: var(--secondary-Text);
  background-color: var(--white);
  height: 36px;
}

.settingsTabs_feedUrlValue__r9CsR {
  flex: 1 1;
  font-size: 13px;
  font-family: monospace;
  color: var(--primary-Text);
  min-width: 0;
  word-break: break-all;
  white-space: normal;
}

.settingsTabs_feedUrlQrContainer__1IJPR {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
}

.settingsTabs_calendarLastError__Bey5t {
  color: #EF4444;
  font-size: 13px;
  margin-top: 8px;
}

.settingsTabs_modalBody__9T2gJ {
  margin-bottom: 0 !important;
}
.settingsTabs_modalBody__9T2gJ .settingsTabs_formBox__2dpd0 {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.settingsTabs_modalBtns__EgDh- {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  gap: 16px;
}
.settingsTabs_modalBtns__EgDh- .settingsTabs_modalBtnsLeft__y6h4D {
  display: flex;
  gap: 16px;
}

@media (max-width: 768px) {
  .settingsTabs_feedUrlLayout__jMrJs {
    flex-direction: column;
    align-items: flex-start;
  }
  .settingsTabs_feedUrlOrColumn__GDOpn {
    padding: 4px 0;
    justify-content: flex-start;
  }
}
@media (max-width: 575px) {
  .settingsTabs_cardLogo__0M-wv {
    width: 22px;
    height: 22px;
  }
  .settingsTabs_cardTitle__KrP3l {
    font-size: 14px;
  }
  .settingsTabs_cardDescription__zpkYA {
    font-size: 12px;
  }
  .settingsTabs_statusContainer__i5uXs {
    font-size: 12px;
  }
}
@media (max-width: 460px) {
  .settingsTabs_cardHeader__28fK5 {
    flex-wrap: wrap;
    gap: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/settingsTabs/settingsTabs.module.scss"],"names":[],"mappings":"AAAA,yBAAA;AAEA;EACC,WAAA;EACA,YAAA;EACA,oBAAA;EACA,+BAAA;EACA,8BAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,2BAAA;AAAD;AAEC;EACC,2BAAA;AAAF;;AAIA;EACC,kBAAA;EACA,WAAA;EACA,UAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AADD;AAGC;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,+BAAA;AADF;;AAKA;EACC,aAAA;AAFD;;AAKA;EACC,aAAA;EACA,+BAAA;EACA,yCAAA;EACA,8BAAA;AAFD;AAIC;EACC,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,mBAAA;AAFF;AAKC;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AAHF;AAKE;EACC,aAAA;AAHH;AAME;EACC,4BAAA;EACA,4BAAA;EACA,kBAAA;AAJH;AAOE;EACC,kBAAA;EACA,+BAAA;EACA,wBAAA;EACA,SAAA;EACA,4BAAA;EACA,0BAAA;EACA,gBAAA;AALH;AAOG;EAEC,8BAAA;EACA,aAAA;AANJ;AAUE;EACC,aAAA;EACA,qCAAA;EACA,SAAA;AARH;AAUG;EALD;IAME,qCAAA;EAPF;AACF;AAUE;EACC,aAAA;EACA,gBAAA;EACA,SAAA;AARH;AAWE;EACC,aAAA;EACA,SAAA;AATH;AAaC;EACC,WAAA;EACA,iBAAA;EACA,aAAA;EACA,yBAAA;EACA,SAAA;AAXF;;AAeA;EACC,+BAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,8BAAA;AAZD;;AAeA;EACC,aAAA;EACA,8BAAA;EACA,uBAAA;AAZD;;AAeA;EACC,aAAA;EACA,SAAA;AAZD;;AAeA;EACC,WAAA;EACA,YAAA;EACA,cAAA;AAZD;AAcC;EACC,WAAA;EACA,YAAA;EACA,mBAAA;AAZF;;AAgBA;EACC,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;AAbD;;AAgBA;EACC,SAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;AAbD;;AAgBA;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AAbD;AAeC;EACC,yBAAA;EACA,qBAAA;AAbF;AAgBC;EACC,4BAAA;EACA,0BAAA;AAdF;;AAkBA;EACC,WAAA;EACA,YAAA;EACA,mBAAA;AAfD;;AAkBA;EACC,iBAAA;AAfD;;AAkBA;EACC,0BAAA;EACA,YAAA;EACA,mCAAA;AAfD;;AAkBA;EACC,4BAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;AAfD;;AAkBA;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AAfD;;AAkBA;EACC,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;AAfD;;AAkBA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAfD;;AAkBA;EACC,eAAA;EACA,4BAAA;AAfD;;AAkBA;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AAfD;;AAkBA;EACC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;AAfD;;AAkBA;EACC,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACC,gBAAA;EACA,cAAA;AAfF;;AAkBA;EACC,aAAA;EACA,sBAAA;EACA,QAAA;AAfD;;AAmBA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;EACA,yBAAA;EACA,mBAAA;AAhBD;;AAmBA;EACC,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;AAhBD;;AAmBA;EACC,aAAA;EACA,SAAA;EACA,mBAAA;EACA,sBAAA;AAhBD;;AAmBA;EACC,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,4BAAA;EACA,8BAAA;EACA,YAAA;AAhBD;;AAmBA;EACC,SAAA;EACA,eAAA;EACA,sBAAA;EACA,0BAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;AAhBD;;AAmBA;EACC,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,uBAAA;AAhBD;;AAmBA;EACC,cAAA;EACA,eAAA;EACA,eAAA;AAhBD;;AAoBA;EACC,2BAAA;AAjBD;AAmBC;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AAjBF;;AAqBA;EACC,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;AAlBD;AAoBC;EACC,aAAA;EACA,SAAA;AAlBF;;AAsBA;EACE;IACE,sBAAA;IACA,uBAAA;EAnBF;EAsBA;IACE,cAAA;IACA,2BAAA;EApBF;AACF;AAuBA;EACC;IACC,WAAA;IACA,YAAA;EArBA;EAwBD;IACC,eAAA;EAtBA;EAyBD;IACC,eAAA;EAvBA;EA0BD;IACC,eAAA;EAxBA;AACF;AA2BA;EACC;IACC,eAAA;IACE,SAAA;EAzBF;AACF","sourcesContent":["/* Information settings */\r\n\r\n.uploadCircle {\r\n\twidth: 96px;\r\n\theight: 96px;\r\n\tborder-radius: 500px;\r\n\tborder: 2px solid var(--border);\r\n\tbackground-color: var(--white);\r\n\tcolor: var(--secondary-Text);\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\ttext-align: center;\r\n\tcursor: pointer;\r\n\tposition: relative;\r\n\tfont: var(--body-font-four);\r\n\r\n\tspan {\r\n\t\tfont: var(--body-font-four);\r\n\t}\r\n}\r\n\r\n.cameraIcon {\r\n\tposition: absolute;\r\n\tbottom: 0px;\r\n\tright: 0px;\r\n\tbackground-color: var(--brand);\r\n\tcolor: var(--white);\r\n\tborder-radius: 50%;\r\n\twidth: 28px;\r\n\theight: 28px;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\r\n\timg {\r\n\t\twidth: 100%;\r\n\t\theight: 100%;\r\n\t\tobject-fit: contain;\r\n\t\tpadding: 4px;\r\n\t\tfilter: brightness(0) invert(1);\r\n\t}\r\n}\r\n\r\n.horizontal {\r\n\tdisplay: flex;\r\n}\r\n\r\n.profileCard {\r\n\tpadding: 20px;\r\n\tborder: 1px solid var(--border);\r\n\tborder-radius: var(--border-radius-large);\r\n\tbackground-color: var(--white);\r\n\r\n\t.boxTitle {\r\n\t\tfont: var(--h6);\r\n\t\tfont-weight: 600;\r\n\t\tcolor: var(--primary-Text);\r\n\t\ttext-align: start;\r\n\t\tmargin-bottom: 16px;\r\n\t}\r\n\r\n\t.formBox {\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\tgap: 16px;\r\n\r\n\t\t& p:empty {\r\n\t\t\tdisplay: none;\r\n\t\t}\r\n\r\n\t\tlabel {\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tcolor: var(--secondary-Text);\r\n\t\t\tmargin-bottom: 4px;\r\n\t\t}\r\n\r\n\t\tinput {\r\n\t\t\tborder-radius: 8px;\r\n\t\t\tborder: 1px solid var(--border);\r\n\t\t\tbackground: var(--white);\r\n\t\t\tmargin: 0;\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t\tfont-weight: 500;\r\n\r\n\t\t\t&:focus,\r\n\t\t\t&:focus-visible {\r\n\t\t\t\tborder: 1px solid var(--brand);\r\n\t\t\t\toutline: none;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.formInputs {\r\n\t\t\tdisplay: grid;\r\n\t\t\tgrid-template-columns: repeat(2, 1fr);\r\n\t\t\tgap: 16px;\r\n\r\n\t\t\t@media (max-width: 499px) {\r\n\t\t\t\tgrid-template-columns: repeat(1, 1fr);\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.formGroupInnerBox {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: end;\r\n\t\t\tgap: 16px;\r\n\t\t}\r\n\r\n\t\t.formBtns {\r\n\t\t\tdisplay: flex;\r\n\t\t\tgap: 10px;\r\n\t\t}\r\n\t}\r\n\r\n\t.buttonContainer {\r\n\t\twidth: 100%;\r\n\t\ttext-align: right;\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: flex-end;\r\n\t\tgap: 16px;\r\n\t}\r\n}\r\n\r\n.integrationCard {\r\n\tborder: 1px solid var(--border);\r\n\tborder-radius: 12px;\r\n\tpadding: 16px 16px 0 16px;\r\n\tmargin-bottom: 0;\r\n\tbackground-color: var(--white);\r\n}\r\n\r\n.cardHeader {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: flex-start;\r\n}\r\n\r\n.cardHeaderLeft {\r\n\tdisplay: flex;\r\n\tgap: 16px;\r\n}\r\n\r\n.cardLogo {\r\n\twidth: 40px;\r\n\theight: 40px;\r\n\tflex-shrink: 0;\r\n\r\n\timg {\r\n\t\twidth: 100%;\r\n\t\theight: 100%;\r\n\t\tobject-fit: contain;\r\n\t}\r\n}\r\n\r\n.cardTitle {\r\n\tmargin: 0 0 4px 0;\r\n\tfont-weight: 600;\r\n\tfont-size: 16px;\r\n\tcolor: var(--primary-Text);\r\n}\r\n\r\n.cardDescription {\r\n\tmargin: 0;\r\n\tcolor: var(--secondary-Text);\r\n\tfont-size: 14px;\r\n\tline-height: 20px;\r\n}\r\n\r\n.statusBadge {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 4px;\r\n\tpadding: 2px 10px;\r\n\tborder-radius: 9999px;\r\n\tfont-size: 12px;\r\n\tfont-weight: 500;\r\n\r\n\t&.connected {\r\n\t\tbackground-color: #EDF7EE;\r\n\t\tcolor: var(--success);\r\n\t}\r\n\r\n\t&.disconnected {\r\n\t\tbackground-color: var(--bg3);\r\n\t\tcolor: var(--primary-Text);\r\n\t}\r\n}\r\n\r\n.statusIcon {\r\n\twidth: 10px;\r\n\theight: 10px;\r\n\tobject-fit: contain;\r\n}\r\n\r\n.cardActions {\r\n\tmargin-left: 16px;\r\n}\r\n\r\n.sectionDivider {\r\n\tmargin: 16px -16px 0 -16px;\r\n\tborder: none;\r\n\tborder-top: 1px solid var(--border);\r\n}\r\n\r\n.integrationCardConnectedContent {\r\n\tbackground-color: var(--bg3);\r\n\tborder-radius: 8px;\r\n\tpadding: 16px;\r\n\tmargin: 0 -16px;\r\n}\r\n\r\n.statusContainer {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 8px;\r\n\tmargin-top: 12px;\r\n\tfont-size: 14px;\r\n\tfont-weight: 500;\r\n\tcolor: var(--primary-Text);\r\n}\r\n\r\n.sectionHeader {\r\n\tfont-size: 14px;\r\n\tfont-weight: 600;\r\n\tcolor: var(--primary-Text);\r\n\tmargin-bottom: 16px;\r\n}\r\n\r\n.settingRow {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n}\r\n\r\n.settingRowLabel {\r\n\tfont-size: 14px;\r\n\tcolor: var(--secondary-Text);\r\n}\r\n\r\n.settingsGroup {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 12px;\r\n}\r\n\r\n.feedUrlBox {\r\n\tmargin-top: 0;\r\n\tmargin-bottom: 16px;\r\n\tbackground-color: #F9FAFB;\r\n\tpadding: 16px;\r\n\tborder-radius: 8px;\r\n}\r\n\r\n.feedUrlLayout {\r\n\tdisplay: flex;\r\n\talign-items: flex-start;\r\n\tjustify-content: center;\r\n\tgap: 24px;\r\n  max-width: 720px;  \r\n  margin: 0 auto;   \r\n}\r\n\r\n.feedUrlColumn {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 8px;\r\n\t// flex: 1;\r\n}\r\n\r\n.feedUrlOrColumn {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tpadding: 0 8px;\r\n\tfont-size: 12px;\r\n\tfont-weight: 600;\r\n\tcolor: var(--secondary-Text);\r\n\ttext-transform: uppercase;\r\n\twhite-space: nowrap;\r\n}\r\n  \r\n.feedUrlLabel {\r\n\tmargin: 0 0 8px 0;\r\n\tfont-size: 14px;\r\n\tfont-weight: 500;\r\n\tcolor: var(--secondary-Text);\r\n}\r\n\r\n.feedUrlInputRow {\r\n\tdisplay: flex;\r\n\tgap: 10px;\r\n\talign-items: center;\r\n\tflex-direction: column;\r\n}\r\n\r\n.feedUrlInput {\r\n\tflex: 1;\r\n\tpadding: 8px 12px;\r\n\tborder-radius: 6px;\r\n\tborder: 1px solid var(--border);\r\n\tfont-size: 13px;\r\n\tcolor: var(--secondary-Text);\r\n\tbackground-color: var(--white);\r\n\theight: 36px;\r\n}\r\n\r\n.feedUrlValue {\r\n\tflex: 1;\r\n\tfont-size: 13px;\r\n\tfont-family: monospace;\r\n\tcolor: var(--primary-Text);\r\n\tmin-width: 0;\r\n\tword-break: break-all;\r\n\twhite-space: normal;\r\n}\r\n\r\n.feedUrlQrContainer {\r\n\tmargin-top: 12px;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 8px;\r\n\talign-items: flex-start;\r\n}\r\n\r\n.calendarLastError {\r\n\tcolor: #EF4444;\r\n\tfont-size: 13px;\r\n\tmargin-top: 8px;\r\n}\r\n\r\n\r\n.modalBody {\r\n\tmargin-bottom: 0 !important;\r\n\r\n\t.formBox {\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\tgap: 16px;\r\n\t}\r\n}\r\n\r\n.modalBtns {\r\n\tmargin-top: 20px;\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\tgap: 16px;\r\n\r\n\t.modalBtnsLeft {\r\n\t\tdisplay: flex;\r\n\t\tgap: 16px;\r\n\t}\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .feedUrlLayout {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .feedUrlOrColumn {\r\n    padding: 4px 0;\r\n    justify-content: flex-start;\r\n  }\r\n}\r\n\r\n@media (max-width: 575px) {\r\n\t.cardLogo {\r\n\t\twidth: 22px;\r\n\t\theight: 22px;\r\n\t}\r\n\r\n\t.cardTitle {\r\n\t\tfont-size: 14px;\r\n\t}\r\n\r\n\t.cardDescription {\r\n\t\tfont-size: 12px;\r\n\t}\r\n\t\r\n\t.statusContainer {\r\n\t\tfont-size: 12px;\r\n\t}\r\n}\r\n\r\n@media (max-width: 460px) {\r\n\t.cardHeader{\r\n\t\tflex-wrap: wrap;\r\n    gap: 10px;\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"uploadCircle": `settingsTabs_uploadCircle__wsTTO`,
	"cameraIcon": `settingsTabs_cameraIcon__SdS06`,
	"horizontal": `settingsTabs_horizontal__TZrh3`,
	"profileCard": `settingsTabs_profileCard__v91UT`,
	"boxTitle": `settingsTabs_boxTitle__uCiu7`,
	"formBox": `settingsTabs_formBox__2dpd0`,
	"formInputs": `settingsTabs_formInputs__yajrF`,
	"formGroupInnerBox": `settingsTabs_formGroupInnerBox__5SQw1`,
	"formBtns": `settingsTabs_formBtns__ApapP`,
	"buttonContainer": `settingsTabs_buttonContainer__1Bk3+`,
	"integrationCard": `settingsTabs_integrationCard__fWmok`,
	"cardHeader": `settingsTabs_cardHeader__28fK5`,
	"cardHeaderLeft": `settingsTabs_cardHeaderLeft__B-iqJ`,
	"cardLogo": `settingsTabs_cardLogo__0M-wv`,
	"cardTitle": `settingsTabs_cardTitle__KrP3l`,
	"cardDescription": `settingsTabs_cardDescription__zpkYA`,
	"statusBadge": `settingsTabs_statusBadge__UT+eo`,
	"connected": `settingsTabs_connected__Q3BZ9`,
	"disconnected": `settingsTabs_disconnected__YNVtE`,
	"statusIcon": `settingsTabs_statusIcon__ESDyg`,
	"cardActions": `settingsTabs_cardActions__94trI`,
	"sectionDivider": `settingsTabs_sectionDivider__VBMeK`,
	"integrationCardConnectedContent": `settingsTabs_integrationCardConnectedContent__TWSCs`,
	"statusContainer": `settingsTabs_statusContainer__i5uXs`,
	"sectionHeader": `settingsTabs_sectionHeader__ZtNfo`,
	"settingRow": `settingsTabs_settingRow__9am6n`,
	"settingRowLabel": `settingsTabs_settingRowLabel__QN8X6`,
	"settingsGroup": `settingsTabs_settingsGroup__38B9a`,
	"feedUrlBox": `settingsTabs_feedUrlBox__OOJct`,
	"feedUrlLayout": `settingsTabs_feedUrlLayout__jMrJs`,
	"feedUrlColumn": `settingsTabs_feedUrlColumn__8ODDm`,
	"feedUrlOrColumn": `settingsTabs_feedUrlOrColumn__GDOpn`,
	"feedUrlLabel": `settingsTabs_feedUrlLabel__vVLG+`,
	"feedUrlInputRow": `settingsTabs_feedUrlInputRow__roVJw`,
	"feedUrlInput": `settingsTabs_feedUrlInput__gmmvC`,
	"feedUrlValue": `settingsTabs_feedUrlValue__r9CsR`,
	"feedUrlQrContainer": `settingsTabs_feedUrlQrContainer__1IJPR`,
	"calendarLastError": `settingsTabs_calendarLastError__Bey5t`,
	"modalBody": `settingsTabs_modalBody__9T2gJ`,
	"modalBtns": `settingsTabs_modalBtns__EgDh-`,
	"modalBtnsLeft": `settingsTabs_modalBtnsLeft__y6h4D`
};
export default ___CSS_LOADER_EXPORT___;
